
/*
For multiple choice responses:
  -1 = Unsure
  0 = No
  1 = Yes
 */


export function chipCapeTrafficLevels(project) {
  return {
    key: "trafficLevels",
    title: "Traffic Levels",
    message:
      "While appropriate for all traffic levels, Chip Seals tend to perform best on routes with at most 10,000 ADT (Average Daily Traffic)."
  };
}

export function chipCapeTurningMovements(project) {
  const a = project.twoWayTurnPresent === 1 || project.twoWayTurnPresent === -1;
  const b = project.intersectionPresent === 1;

  if (a && b) {
    return {
      key: "turningMovements",
      title: "Turning Movements",
      message:
        "You indicated (or are uncertain of) the presence of two-way left turn lane(s) or an intersection in your segment.  Compared to the rest of your segment, these areas may have different loading conditions  and consequently, pavement designs. If your roadway experiences significant turning movement, a chip or cape seal is not recommended for these areas. Istead for these areas, consider a 3/8-inch asphalt overlay at the intersection of aterials and collectors, and at the intersections subject to regular heavy vehicles (e.g. buses, dump trucks) turning movements. Turning movements on an uncured surface may result in scuff marks."
    };
  }
}

export function chipCapeAlligator(project){
  if (project.alligatorCrackingSeverity > 0 && project.alligatorCrackingExtent < 15){
    return {
      title: 'Pavement Distress (Alligator Cracking)',
      message: 'You indicated (or are uncertain of) the presence of High Severity alligator cracking with an Extent less than 15% of the wheelpath area. In such cases, these small, localized areas should be repaired and patched prior to chip sealing.'
    }
  }
}

export function chipCapeTransverseLongitudinal(project){
  if (project.transverseCrackingSeverity > 0 || project.longitudinalCrackingSeverity > 0){
    return {
      title: 'Pavement Distress (Transverse and/or Longitudinal Cracking)',
      message: 'You indicated the presence of transverse and/or longitudinal cracking. Cracks greater than 1/8 inch should be crack sealed and completely cured prior to chip sealing.'
    }
  }
}

export function chipCapeBleedFlush(project){
  if (project.bleedFlushSeverity > 0){
    return {
      title: 'Pavement Distress (Bleed/Flush)',
      message: 'You indicated the presence of bleeding or flushing on your segment. You should repair any flushed areas on the surface before the chip seal application. Placing chip seals over existing flushed surfaces may result in flushing/bleeding reappearing on the new chip seal'
    }
  }
}

export function chipCapeAC1(project){
  if (project.isWheelPathFlushing === 1 && project.requireSmoothMacrotexture === 1){
    return {
      title: 'Additional Considerations',
      message: 'Consider a double chip seal in the wheelpaths, and a cape seal to provide smooth macro-texture.'
    }
  }
}
export function chipCapeAC2(project){
  if (project.isWheelPathFlushing === 1 && project.requireSmoothMacrotexture === 0){
    return {
      title: 'Additional Considerations',
      message: 'Consider a double chip seal in the wheelpaths.'
    }
  }
}
export function chipCapeAC3(project){
  if (project.isWheelPathFlushing === 0 && project.requireSmoothMacrotexture === 1){
    return {
      title: 'Additional Considerations',
      message: 'Consider a cape seal to provide smooth macro-texture.'
    }
  }
}

/*
AC4 deprecated as not necessary
*/

// export function chipCapeAC4(project){
//   if (project.isWheelPathFlushing === 0 && project.requireSmoothMacrotexture === 0){
//     return {
//       title: 'Additional Considerations',
//       message: 'Chip Seal is a viable treatment option.'
//     }
//   }
// }

export function chipCapeAC5(project){
  if (project.isWheelPathFlushing === -1 || project.requireSmoothMacrotexture === -1){
    return {
      title: 'Additional Considerations',
      message: 'Chip Seal is a viable treatment option, but you have indicated uncertainty for some inputs. ' +
        'If there is moderate flushing in the wheelpath, you may need to consider a doublechip seal in the wheelpaths; additionally, if your design requires a smooth macro-texture, you may need to consider a cape seal to accomplish this.'
    }
  }
}
